import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { model as router } from '!/router'
import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { versions } from '~/app'
import { formatExpirationDate } from '~/shared/helpers/date'
import { getTimezone } from './helpers'

export const init = createEvent()

const $info = combine(api.session.$session, i18n.$t, (session) => ({
  ...session, // TODO: get rid of `content` field later
  expirationTime: formatExpirationDate(session?.expirationTime),
  timezone: getTimezone(session?.timezone),
  versions,
}))

const backToSettings = createEvent()

sample({
  clock: backToSettings,
  fn: () => '/modules/settings',
  target: router.navigatePush,
})

register($info, '$settings/info/info')
register(backToSettings, 'settings/info/backToSettings')
